import React, { useEffect } from "react";

function AlertMessage({ type, message, onClose, duration = 30000 }) {
  const baseStyle =
    "flex p-4 mb-4 text-sm rounded-lg dark:bg-gray-800 w-full";
  const styleMap = {
    error: `${baseStyle} text-red-800 bg-red-50 dark:text-red-400`,
    success: `${baseStyle} text-green-800 bg-green-50 dark:text-green-400`,
  };

  // 🔹 Auto close after duration
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        onClose();
      }, duration); // default 3 seconds
      return () => clearTimeout(timer);
    }
  }, [message, duration, onClose]);

  if (!message) return null;

  return (
    <div className={styleMap[type]} role="alert">
      <svg
        className="shrink-0 inline w-4 h-4 me-3 mt-[2px]"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
      </svg>
      <div>
        <span className="font-medium">
          {type === "error" ? "Error: " : "Success: "}
        </span>
        {message}
      </div>
      <button
        type="button"
        onClick={onClose}
        className="ms-auto -mx-1.5 -my-1.5 bg-transparent text-current rounded-lg focus:ring-2 p-1.5 hover:bg-gray-200 inline-flex items-center justify-center h-8 w-8"
      >
        <span className="sr-only">Close</span>
        <svg
          className="w-3 h-3"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 14 14"
        >
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
          />
        </svg>
      </button>
    </div>
  );
}

export default AlertMessage;